import { render, staticRenderFns } from "./ApplicantsImportIndex.vue?vue&type=template&id=2c35fc01"
import script from "./ApplicantsImportIndex.vue?vue&type=script&lang=js"
export * from "./ApplicantsImportIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports